import { Component } from '@angular/core';

@Component({
  selector: 'smart-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
  title = 'Messaging Portal';
}
